module.exports = __webpack_public_path__ + "media/images/excellent_smiley_selected-de8fa6da9a3fa9aa878dd788cbc89213.svg";